<button
  cdkOverlayOrigin
  #trigger="cdkOverlayOrigin"
  type="button"
  (click)="isOverlayOpened = !isOverlayOpened"
  mat-button
  class="select-btn"
>
  {{ selectedRange.label }}
  <span class="material-symbols-outlined select-btn__icon">
    {{ !isOverlayOpened ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}
  </span>
</button>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOverlayOpened"
  (overlayOutsideClick)="isOverlayOpened = false"
  [cdkConnectedOverlayPositions]="OVERLAY_POSITIONS"
  cdkConnectedOverlayPush="true"
  [cdkConnectedOverlayViewportMargin]="7"
>
  <app-date-range-calendar
    [maxDate]="maxDate"
    [rangeValue]="selectedRange.dateRange"
    (onCalenderChanged)="onCalenderChanged($event)"
  />
</ng-template>
